// 控制父群組「平台」「網站」是否顯示 NEW pill 標記
// 上線一段時間後可改為 false 關閉
export const SHOW_NEW_BADGES = true;
